import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ElementRef,
  HostListener,
} from '@angular/core';

export interface IContextMenuItem {
  label: string;
  icon: string;
  action: () => void;
  danger?: boolean;
  disabled?: boolean;
}

@Component({
  selector: 'irembogov-fb-context-menu',
  templateUrl: './fb-context-menu.component.html',
  styleUrls: ['./fb-context-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FbContextMenuComponent {
  visible = false;
  posX = 0;
  posY = 0;
  items: IContextMenuItem[] = [];

  constructor(private elementRef: ElementRef, private cdr: ChangeDetectorRef) {}

  show(event: MouseEvent, items: IContextMenuItem[]): void {
    event.preventDefault();
    event.stopPropagation();
    this.items = items;
    this.posX = event.clientX;
    this.posY = event.clientY;
    this.visible = true;
    this.cdr.markForCheck();
  }

  hide(): void {
    this.visible = false;
    this.items = [];
    this.cdr.markForCheck();
  }

  onItemClick(item: IContextMenuItem): void {
    if (item.disabled) return;
    item.action();
    this.hide();
  }

  trackByIndex(index: number): number {
    return index;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (this.visible && !this.elementRef.nativeElement.contains(event.target)) {
      this.hide();
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.visible) {
      this.hide();
    }
  }
}
